/**--external-- */
import React from "react";
import PropTypes from "prop-types";

/**--internal-- */
import { useI18n } from "Hooks";
import { colors } from "Constants";
import { VIEW_MODE } from "Constants/stringConstants";
import { getWeekDaysOptions, getDaysNameOrIndexArray } from "Utils";

/**--relative-- */
import CheckListContainer from "UIComponents/CheckListContainer";
import {
  checkBoxLabelStyles,
  listItemStyle,
  checkboxItemStyle,
} from "./OperationalDaysStyles";

const OperationalDays = props => {
  const { t } = useI18n(["common"]);

  const {
    updateOperationalDays,
    operationalDays,
    mode,
    testId,
    customLabelClass = "",
    dsVersion = "1.0",
    checkListContainerStyle = {},
    listItemStyle: listItemStyleLocal,
  } = props;

  const isDSVersionV2 = dsVersion === "2.0";

  const updateInputField = value => {
    const operationalDaysIndices = getDaysNameOrIndexArray({
      array: value,
      type: "index",
      format: isDSVersionV2 && "fullName",
    });
    updateOperationalDays(operationalDaysIndices);
  };

  const localTestId = testId ? `${testId}-operationalDays` : "operationalDays";

  return (
    <CheckListContainer
      label={t("common:operationalDays")}
      options={getWeekDaysOptions(isDSVersionV2)}
      updateInputField={updateInputField}
      value={getDaysNameOrIndexArray({
        array: operationalDays,
        format: isDSVersionV2 && "fullName",
      })}
      checkboxItemStyle={checkboxItemStyle}
      listItemStyle={{ ...listItemStyle, ...listItemStyleLocal }}
      CheckBoxLabelStyles={checkBoxLabelStyles}
      fillColor={colors.violet500}
      checkBoxSize={isDSVersionV2 ? "medium" : "xx-small"}
      dsVersion={dsVersion}
      disabled={mode === VIEW_MODE}
      testId={localTestId}
      customLabelClass={customLabelClass}
      checkListContainerStyle={checkListContainerStyle}
    />
  );
};

export default OperationalDays;

OperationalDays.propTypes = {
  updateOperationalDays: PropTypes.func.isRequired,
  operationalDays: PropTypes.array,
};
